var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-btn',{attrs:{"fixed":"","right":"","icon":"","fab":""},on:{"click":_vm.close}},[_c('v-icon',[_vm._v("mdi-close")])],1),_c('v-card-text',{staticClass:"pa-5",attrs:{"align":"left"}},[_c('SchemaInfoNode',{attrs:{"schema":_vm.schema}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }